import { defineStore } from 'pinia';
import { IReportCard } from '@cyber-range/cyber-range-api-ctf-submission-client';
import { useApiClientStore } from './apiClientStore';

export const useReportCardStore = defineStore('reportCardStore',
{
    state: () =>
    ({
        reportCard: undefined as IReportCard | undefined,
        reportCardId: undefined as string | undefined,
    }),

    actions:
    {
        async createReportCard(playerId: string): Promise<string>
        {
            this.reportCardId = await useApiClientStore().submissionApiClient.createPlayerReportCard(playerId);
            return this.reportCardId;
        },

        async fetchReportCard(reportCardId: string): Promise<IReportCard>
        {
            this.reportCard = await useApiClientStore().submissionApiClient.getReportCard(reportCardId);
            return this.reportCard;
        }
    }
});
